import React from 'react'
import { LiveMatchItem } from './LiveMatchItem'
import { useStatsPerformMatch } from '../../contexts/StatsPerformMatchesContext'
import { LiveMatchPostFormatted } from '../../types'
import { flagUrl } from '../../shared/utils'
import { formatToDayJsDate } from '../../utils/statsperform/statsperformUtils'
import { useStatsPerformContestantsData } from '../../hooks/useStatsPerformContestantsData'

const Item = ({ matchFormatted }: { matchFormatted: LiveMatchPostFormatted }) => {
    const match = useStatsPerformMatch(matchFormatted.statsperformid)
    const { homeContestant, awayContestant } = useStatsPerformContestantsData(
        matchFormatted.statsperformid,
    )

    const canDisplay = match?.data?.matchInfo && homeContestant && awayContestant // && match?.data?.liveData

    if (!canDisplay) return null

    return (
        <LiveMatchItem
            href={matchFormatted.link}
            title={`${match!.data!.matchInfo.competition.name} - ${
                match!.data!.matchInfo.round.name
            }`}
            error={match.error}
            homeName={homeContestant?.name ?? ''}
            homeIcon={flagUrl(homeContestant.logo)}
            homeScore={match.data?.liveData?.matchDetails.scores?.final?.home}
            awayName={awayContestant?.name ?? ''}
            awayIcon={flagUrl(awayContestant.logo)}
            awayScore={match.data?.liveData?.matchDetails.scores?.final?.away}
            status={match.data?.liveData?.matchDetails.matchStatus ?? 'Fixture'}
            date={formatToDayJsDate(match.data!.matchInfo)}
        />
    )
}

export const LiveMatchesItemsDesktop = ({ liveMatchs }: { liveMatchs: LiveMatchPostFormatted[] }) =>
    liveMatchs ? (
        <>
            {liveMatchs.map((x) => (
                <Item key={x.post_id} matchFormatted={x} />
            ))}
        </>
    ) : null
